import React, {CSSProperties} from "react";

export const ErrorCodeExplanation: React.FC<{style?: CSSProperties}> = ({style, children}) => {
    return <span style={{
      color: '#66798d',
      ...style,
    }}>“{children}”</span>;
};
